import type { Dispatch, SetStateAction } from 'react'
import type { DialogAPI } from '../Dialog'

export function apiFactory(
	setOpened: Dispatch<SetStateAction<boolean>>,
	element: HTMLDialogElement | null
): DialogAPI {
	return {
		show: () => setOpened(true),
		close: () => setOpened(false),
		open: !!element?.open,
		element,
	}
}
